import { render } from "./PatientsList.vue?vue&type=template&id=b9989800&ts=true"
import script from "./PatientsList.vue?vue&type=script&lang=ts"
export * from "./PatientsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Patient/PatientsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9989800"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9989800', __exports__)) {
    api.reload('b9989800', __exports__)
  }
  
  module.hot.accept("./PatientsList.vue?vue&type=template&id=b9989800&ts=true", () => {
    api.rerender('b9989800', render)
  })

}


export default __exports__